import React from 'react';
import { User, Award, Heart, Scissors } from 'lucide-react';
import { barbershopInfo, features } from '../data/mock';

const AboutSection = () => {
  const featureIcons = [Heart, Award, User];

  return (
    <section id="about" className="py-20 sm:py-32 bg-slate-950 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #c9a962 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" dir="rtl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="h-px w-12 bg-[#c9a962]" />
            <Scissors className="w-5 h-5 text-[#c9a962]" />
            <div className="h-px w-12 bg-[#c9a962]" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            אודות <span className="text-[#c9a962]">המספרה</span>
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            הכירו את {barbershopInfo.owner} והחזון שמאחורי NY Barbershop
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              {/* Main Image */}
              <div className="relative overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_9e6d1a7c-82a4-4b2d-8ddf-ccb16822431b/artifacts/wks5zhi4_image.png"
                  alt="NY Barbershop Front"
                  className="w-full h-[400px] sm:h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" />
              </div>
              
              {/* Decorative Frame */}
              <div className="absolute -top-4 -right-4 w-full h-full border-2 border-[#c9a962]/30 -z-10" />
              
              {/* Badge */}
              <div className="absolute bottom-6 right-6 bg-slate-950/90 backdrop-blur-sm border border-[#c9a962]/30 px-6 py-4">
                <p className="text-[#c9a962] font-bold text-2xl">NY</p>
                <p className="text-slate-400 text-sm">Barbershop</p>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2">
            <div className="space-y-6">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
                  שלום, אני {barbershopInfo.owner}
                </h3>
                <p className="text-slate-300 text-lg leading-relaxed">
                  {barbershopInfo.description}
                </p>
              </div>

              {/* Features */}
              <div className="grid gap-4 pt-6">
                {features.map((feature, index) => {
                  const Icon = featureIcons[index];
                  return (
                    <div
                      key={feature.id}
                      className="flex items-start gap-4 p-4 bg-slate-900/50 border border-slate-800 hover:border-[#c9a962]/30 transition-colors duration-300 group"
                    >
                      <div className="w-12 h-12 bg-[#c9a962]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#c9a962]/20 transition-colors">
                        <Icon className="w-6 h-6 text-[#c9a962]" />
                      </div>
                      <div>
                        <h4 className="text-white font-semibold text-lg mb-1">
                          {feature.title}
                        </h4>
                        <p className="text-slate-400 text-sm">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
